import React, { Component } from "react";
import {
  saveSideBarState,
  retrieveSideBarState
} from "../../utils/localStorage";
import "./SideBar.css";
import { Link } from "react-router-dom";
import Sqaure from "../Square/Square";
import { logger } from "../../utils/logger";
import { Nav, NavItem, Collapse } from "reactstrap";
import { planningValues } from "../../utils/constants";
import { storyValues } from "../../utils/constants";
import { staticTitles } from "../../utils/constants";


class MemberSideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accordion: [false, false, false, false],
      accordinonTabs: 0,
      activityCategories: planningValues,
      storyCategories:storyValues,
      path: this.props.location.pathname.split('/')
    };
  }

  toggleAccordion(tab) {
    // console.log(tab)
    const prevState = this.state.accordion;
    const state = prevState.map((x, index) => (tab === index ? !x : false));
    // console.log(state)
    this.setState({
      accordion: state
    });
    saveSideBarState(state);
  }

  componentWillReceiveProps(nextProps) {
    
    // change this if you change order of NavBar
    console.log(this.state.path,'---again--', nextProps.location.pathname.split('/'))

    if(this.state.path!==nextProps.location.pathname.split('/')){    
      this.setState({path:nextProps.location.pathname.split('/')})
    }

    let { pathname } = nextProps.location;
    if (pathname.startsWith("/home/toolkit")) {
      this.setState({ accordion: [false, false, false, true] });
    } else if (pathname.startsWith("/home/analytics")) {
      this.setState({ accordion: [false, false, true,  false] });
    } else if (pathname.startsWith("/home/my-activity")) {
      this.setState({ accordion: [false, true, false, false] });
    } else if (pathname.startsWith("/home/stories")) {
      this.setState({ accordion: [true,false, false, false] });
    } else if (pathname.startsWith("/home/dashboard")) {
      this.setState({ accordion: [false, false, false, false] });
    }
  }

  componentDidMount() {
    console.log('this---', this.props.location.pathname.split('/'))
    if (retrieveSideBarState() !== null) {
      let retrivedSideBarState = retrieveSideBarState().split(",");
      retrivedSideBarState = retrivedSideBarState.map(state => {
        if (state === "true") return true;
        else return false;
      });
      this.setState({ accordion: retrivedSideBarState });
    }

    this.setState({path:this.props.location.pathname.split('/')})
    let pathname = this.props.location.pathname;
    // console.log(pathname)
    if (pathname.indexOf("toolkit") > -1) {
      this.setState({ accordion: [false, false, false, true] });
    } else if (pathname.indexOf("analytics") > -1) {
      this.setState({ accordion: [false, false, true,  false] });
    } else if (pathname.indexOf("stories") > -1) {
      this.setState({ accordion: [true, false, false, false] });
    } else if (pathname.indexOf("dashboard") > -1) {
      this.setState({ accordion: [false, false, false, false] });
    }
  }

  isWeeklyWinsUrl = () => {
    return this.props.location.pathname.indexOf("my-activity") > -1;
  };
  isToolkitUrl = () => {
    return this.props.location.pathname.indexOf("toolkit") > -1;
  };
  isAnalyticsUrl = () => {
    return this.props.match.url.indexOf("analytics") > -1;
  };
  render() {
    let { toolCategory } = { ...this.props.currentTool.category };
    // let path = this.props.location.pathname.split("/");
    let {path} = this.state

    return (
      
      <div className="col-md-2 col-sm-2 sidebar no-padding side-navbar-bg position-fixed" style={{ borderBottom: "1px solid #E7E7E9" }} >
          <div
            onClick={() => this.toggleAccordion(0)}
            className="sidebar-category-section"
          >
            <div
              className="sidebar-menuItem"
              style={{ fontWeight: this.state.accordion[0] ? "600" : "normal" }}
            >
              {staticTitles.stories}
            </div>
            <div
              style={{
                display: "flex",
                color: "#3B3C41",
                opacity: this.state.accordion[0] ? "" : "0.4"
              }}
            >

              <i className="flaticon-down-arrow sidebar-flaticon-down-arrow" />
            </div>
            
          </div>


          <Collapse
            isOpen={this.state.accordion[0]}
            style={{ paddingBottom: "20px", marginTop: "-15px" }}
          >
            <Nav vertical className="category-wrapper">
              {this.state.storyCategories.map((category, i) => {
                let link = this.props.match.url + "/stories" + category.link!==""?"/"+category.link:"";
                if (link.indexOf("me") > -1) {
                  return (
                    <NavItem
                      key={i}
                      className="nav-item text-md mt10"
                      // className={
                      //   category.link === "me"
                      //     ? "nav-item text-md mt10"
                      //     : "sideBarNone"
                      // }
                    >
                      <span className="sidebar-category">
                        <Link
                          to={this.props.match.url + "/stories/" + category.link}
                          className={
                            path.indexOf("home") > -1 &&
                            path.indexOf(category.link) > -1
                              ? "category-active"
                              : "category"
                          }
                        >
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  );
                }
                else if (link.indexOf("archived") > -1) {
                  return (
                    <NavItem
                      key={i}
                      className="nav-item text-md mt10"
                      // className={
                      //   category.link === "archived"
                      //     ? "nav-item text-md mt10"
                      //     : "sideBarNone"
                      // }
                    >
                      <span className="sidebar-category">
                        <Link
                          to={this.props.match.url + "/stories/" + category.link}
                          className={
                            path.indexOf("home") > -1 &&
                            path.indexOf(category.link) > -1
                              ? "category-active"
                              : "category"
                          }
                        >
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  );
                }
                else {
                  return (
                    <NavItem
                      key={i}
                      className="nav-item text-md mt10"
                      // className={
                      //   category.link === ""
                      //     ? "nav-item text-md mt10"
                      //     : "sideBarNone"
                      // }
                    >
                      <span className="sidebar-category">
                        <Link
                          to={this.props.match.url + "/stories"}
                          className={
                            // path.indexOf("home") > -1 &&
                            // path.indexOf(category.link) > -1 && 
                            path.indexOf("me") === -1 && 
                            path.indexOf("archived") === -1
                              ? "category-active"
                              : "category"
                          }
                        >
                          {category.name}
                        </Link>
                      </span>
                    </NavItem>
                  );
                }
              })}
            </Nav>
          </Collapse>
        
        
        
        
        </div>


    );
  }
}

export default MemberSideBar;
